import { groq } from 'next-sanity'
import ErrorPage from 'next/error'
import { useRouter } from 'next/router'
import T from 'prop-types'

import Video from '@/components/Video'
import { videoQuery } from '../../api'
import { getImageUrl } from '../../api/sanity'
import NavList from '../../components/NavList'
import SanityPreview from '../../components/SanityPreview'
import SEO from '../../components/SEO'
import useColor from '../../hooks/useColor'
import { buildGetStaticPaths, buildGetStaticProps } from '../../lib/page'

const query = groq`
  *[_type == "video" && slug.current == $slug]${videoQuery} | order(_updatedAt desc)[0]
`

export default function Page({ preview, pageData, error, status, slug }) {
  const router = useRouter()
  useColor(null, status)

  if (error) {
    return <ErrorPage statusCode={error.statusCode} title={error.title} />
  }

  if (!router.isFallback && !pageData) {
    return <ErrorPage statusCode={404} />
  }

  return (
    <SanityPreview preview={preview} initialData={pageData} query={query} params={{ slug }}>
      {(video) => {
        return (
          <div>
            <SEO
              title={video?.title}
              description={video?.preamble}
              path={`artikkel/${video?.slug?.current}`}
              image={video?.ogImages?.facebook && getImageUrl(video?.ogImages?.facebook).url()}
              excludeFromSearch={video?.excludeFromSearch}
            />
            <NavList back={{ title: 'Hjem', href: '/' }} />
            {video ? <Video {...video} /> : <p>No video found.</p>}
          </div>
        )
      }}
    </SanityPreview>
  )
}

Page.propTypes = {
  status: T.string,
  pageData: T.shape({
    article: T.object,
  }).isRequired,
  slug: T.string.isRequired,
  preview: T.bool.isRequired,
  error: T.shape({
    statusCode: T.number.isRequired,
    title: T.string.isRequired,
    purpose: T.string,
  }),
}

export const getStaticProps = buildGetStaticProps(query)

export const getStaticPaths = buildGetStaticPaths('video')
